import { useContext } from 'react';

import { ChainsPublicStatsContext } from '../const';

export const useChainsPublicStatsParams = () =>
  useContext(ChainsPublicStatsContext);
